import job1 from '../Images/job1.webp';
import job2 from '../Images/job2.jpg';
import job3 from '../Images/job3.jpg';
import job4 from '../Images/job4.jpg';
import job5 from '../Images/job5.jpg';
import job6 from '../Images/job6.jpg';
import job7 from '../Images/job7.jpg';
import job8 from '../Images/job8.jpg';
import job9 from '../Images/job9.jpg';
import job10 from '../Images/job10.jpg';
import Job11 from '../Images/intern.jpeg';

import webinar1 from '../Images/Webinar1.png';
import webinar2 from '../Images/webinar2.jpg';
import webinar3 from '../Images/webinar3.jpg';
import webinar4 from '../Images/webinar4.png';
import webinar5 from '../Images/Webinar5.jpg';

import seminar1 from '../Images/seminar1.avif';
import seminar2 from '../Images/seminar2.jpeg';
import seminar3 from '../Images/seminar3.jpg';
import seminar4 from '../Images/seminar4.jpg';
import seminar5 from '../Images/seminar5.jpg';

const events = [
  // ===================== Jobs =====================
  {
    id: 1,
    type: "Jobs",
    title: "Internship Program",
    date: "2026-02-10",
    location: "Banglore, India",
    img: Job11,
  desc: "IT and Non-IT internship program with practical training, real-world exposure, and placement assistance for fresh graduates.",

  },
  {
    id: 2,
    type: "Jobs",
    title: "Startup Hiring Drive",
    date: "2026-03-05",
    location: "Delhi, India",
    img: job2,
    desc: "Network with startups and explore career opportunities.",
  },
  {
    id: 3,
    type: "Jobs",
    title: "IT Mega Recruitment",
    date: "2026-03-18",
    location: "Pune, India",
    img: job3,
    desc: "Top IT companies hiring freshers & experienced professionals.",
  },
  {
    id: 4,
    type: "Jobs",
    title: "Banking Recruitment Fair",
    date: "2026-02-20",
    location: "Kolkata, India",
    img: job4,
    desc: "Major banks are hiring for PO, Clerk & Specialist Officer roles.",
  },
  {
    id: 5,
    type: "Jobs",
    title: "Government Job Expo",
    date: "2026-02-25",
    location: "Lucknow, India",
    img: job5,
    desc: "Explore upcoming govt job vacancies and apply directly.",
  },
  {
    id: 6,
    type: "Jobs",
    title: "Healthcare Career Fair",
    date: "2026-03-02",
    location: "Chennai, India",
    img: job6,
    desc: "Hospitals & clinics recruiting doctors, nurses, and paramedical staff.",
  },
  {
    id: 7,
    type: "Jobs",
    title: "Engineering Recruitment Drive",
    date: "2026-03-22",
    location: "Hyderabad, India",
    img: job7,
    desc: "Core companies hiring mechanical, civil & electrical engineers.",
  },
  {
    id: 8,
    type: "Jobs",
    title: "Overseas Job Fair",
    date: "2026-04-05",
    location: "Kerala, India",
    img: job8,
    desc: "Work abroad opportunities in IT, healthcare & construction.",
  },
  {
    id: 9,
    type: "Jobs",
    title: "Women Career Summit",
    date: "2026-04-12",
    location: "Bhopal, India",
    img: job9,
    desc: "Exclusive recruitment drive for women professionals & freshers.",
  },
  {
    id: 10,
    type: "Jobs",
    title: "Freshers Job Mela",
    date: "2026-04-20",
    location: "Jaipur, India",
    img: job10,
    desc: "Campus-style hiring for fresh graduates in multiple domains.",
  },
  {
    id: 21,
    type: "Jobs",
    title: "Career Fair 2026",
    date: "2026-09-15",
    location: "Mumbai, India",
    img: job1,
    desc: "Meet top recruiters, explore job opportunities, and grow your career.",
  },

  // ===================== Webinars =====================
  {
    id: 11,
    type: "Webinar",
    title: "Public Speaking Mastery",
    date: "2026-01-20",
    location: "Online",
    img: webinar1,
    desc: "Overcome stage fear and deliver confident presentations.",
  },
  {
    id: 12,
    type: "Webinar",
    title: "Time Management Training",
    date: "2026-01-25",
    location: "Online",
    img: webinar2,
    desc: "Master the art of productivity and efficiency",
  },
  {
    id: 13,
    type: "Webinar",
    title: "Cybersecurity Awareness",
    date: "2026-02-01",
    location: "Online",
    img: webinar3,
    desc: "Protect yourself from online threats with expert insights.",
  },
  {
    id: 14,
    type: "Webinar",
    title: "Blockchain in Business",
    date: "2026-02-15",
    location: "Online",
    img: webinar4,
    desc: "Explore blockchain applications beyond cryptocurrencies.",
  },
  {
    id: 15,
    type: "Webinar",
    title: "Digital Marketing Strategies",
    date: "2026-03-05",
    location: "Online",
    img: webinar5,
    desc: "Boost your brand with advanced digital marketing techniques.",
  },

  // ===================== Seminars =====================
  {
    id: 16,
    type: "Seminar",
    title: "Tech Workshop",
    date: "2026-02-18",
    location: "Bangalore, India",
    img: seminar1,
    desc: "Hands-on session on Full Stack Development.",
  },
  {
    id: 17,
    type: "Seminar",
    title: "Entrepreneurship Bootcamp",
    date: "2026-03-01",
    location: "Delhi, India",
    img: seminar2,
    desc: "Learn startup skills and meet successful entrepreneurs.",
  },
  {
    id: 18,
    type: "Seminar",
    title: "AI & Robotics Seminar",
    date: "2026-03-10",
    location: "Hyderabad, India",
    img: seminar3,
    desc: "Explore innovations in AI, ML, and robotics technology.",
  },
  {
    id: 19,
    type: "Seminar",
    title: "Leadership & Teamwork",
    date: "2026-03-20",
    location: "Chennai, India",
    img: seminar4,
    desc: "Develop leadership qualities and team management skills.",
  },
  {
    id: 20,
    type: "Seminar",
    title: "Communication Skills Workshop",
    date: "2026-04-05",
    location: "Online",
    img: seminar5,
    desc: "Improve your verbal & written communication skills.",
  },
];

export default events;
